import React from "react"
import { Link } from "gatsby"
import Layout from "antd/es/layout"
import LOGO_TUTOR from "assets/icons/logo-tutor.svg"
import LOGO_BLOG from "assets/icons/logo-blog.svg"
import styled from "styled-components"
import { colors } from "src/styles/colors"
import { useBreakpoints } from "src/lib/hooks/use-breakpoints"
import { APPLICATION_CONTENT_MAX_WIDTH } from "components/commons/commons"
import { AppRoute } from "app/app.route.const"
import { Text } from "components/text/Text"

const { Header } = Layout

type Props = {
  bg?: boolean
}

const Logo = styled.div<any>`
  display: flex;
  align-items: center;
  justify-content: ${({ minWideDesktop }) => (minWideDesktop ? "left" : "center")};
  margin: ${({ minWideDesktop, bg }) =>
    bg ? (minWideDesktop ? "23px 0" : "19px 0") : 0};
`

const Logo_Tutor = styled.img<any>`
  height: 31px;
  max-width: 120px;
`

const Logo_Blog = styled.img<any>`
  max-width: 53px;
  height: 31px;
  margin-top: 3px;
  margin-left: 5px;
  &:hover {
    filter: brightness(1.8);
  }
`

const TextWrapper = styled.div<any>`
  height: 40px;
  display: flex;
  justify-content: center;
  width: 340px;
  opacity: 0.85;
  & a {
    color: ${colors.white};
    font-weight: 600;
    text-decoration: underline;
  }
`

const Background = styled.div<any>`
  display: block;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: ${({ minWideDesktop, bg }) =>
    bg ? (minWideDesktop ? "250px" : "118px") : "64px"};
  width: 100%;
  background-color: ${colors.primary};
  z-index: 0;
`

const StyledHeader = styled(Header)<any>`
  z-index: 1;
  height: 100%;
  background-color: transparent;
  display: flex;
  justify-content: ${({ minWideDesktop }) =>
    minWideDesktop ? "space-between" : "center"};
  align-items: center;
  width: ${({ minWideDesktop }) =>
    minWideDesktop ? `${APPLICATION_CONTENT_MAX_WIDTH}px` : "100%"};
  margin: 0 auto;
  text-align: ${({ minWideDesktop }) => (minWideDesktop ? "left" : "center")};
`

export const MasterHeader: React.FC<Props> = ({ bg = false }) => {
  const { minWideDesktop } = useBreakpoints()

  return (
    <>
      <Background minWideDesktop={minWideDesktop} bg={bg} />
      <StyledHeader bg={bg} minWideDesktop={minWideDesktop}>
        <Logo minWideDesktop={minWideDesktop} bg={bg}>
          <Link to={AppRoute.Tutorspace}>
            <Logo_Tutor src={LOGO_TUTOR} alt="Logo Tutorspace" />
          </Link>
          <Link to={AppRoute.Home}>
            <Logo_Blog src={LOGO_BLOG} alt="Logo Tutorspace Blog" />
          </Link>
        </Logo>
        {minWideDesktop && (
          <TextWrapper>
            <Text
              color={colors.white}
              size={12}
              style={{ lineHeight: "20px", fontStyle: "italic" }}
            >
              Präsentiert von{" "}
              <a href={AppRoute.Tutorspace} target="_blank">
                TutorSpace
              </a>
              , dem gratis Portal mit tausenden bewerteten Nachhilfelehrern,
              -instituten und zufriedenen Eltern.
            </Text>
          </TextWrapper>
        )}
      </StyledHeader>
    </>
  )
}
